import { getEntity } from './_utils'

export const getOverride = getEntity('overrides')
